import { queryRef, executeQuery, mutationRef, executeMutation, validateArgs } from 'firebase/data-connect';

export const QuestionTypeEnum = {
  TEXT: "TEXT",
  SINGLE_SELECT: "SINGLE_SELECT",
  MULTI_SELECT: "MULTI_SELECT",
}

export const StatusForEnum = {
  USERS: "USERS",
  LOCATIONS: "LOCATIONS",
  LISTINGS: "LISTINGS",
  ORDERS: "ORDERS",
  FULFILLMENTS: "FULFILLMENTS",
  REFUNDS: "REFUNDS",
  PROCESSORS: "PROCESSORS",
  CATEGORIES: "CATEGORIES",
  SEGMENTS: "SEGMENTS",
  IMAGES: "IMAGES",
  DISCOUNTS: "DISCOUNTS",
  INTERACTIONS: "INTERACTIONS",
  MESSAGES: "MESSAGES",
  PAYOUTS: "PAYOUTS",
  NOTIFICATIONS: "NOTIFICATIONS",
}

export const connectorConfig = {
  connector: 'account',
  service: 'mobilestorehouse',
  location: 'us-central1'
};

export const getMyUserInformationCheckRef = (dc) => {
  const { dc: dcInstance} = validateArgs(connectorConfig, dc, undefined);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetMyUserInformationCheck');
}
getMyUserInformationCheckRef.operationName = 'GetMyUserInformationCheck';

export function getMyUserInformationCheck(dc) {
  return executeQuery(getMyUserInformationCheckRef(dc));
}

export const getLocationUsersRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetLocationUsers', inputVars);
}
getLocationUsersRef.operationName = 'GetLocationUsers';

export function getLocationUsers(dcOrVars, vars) {
  return executeQuery(getLocationUsersRef(dcOrVars, vars));
}

export const getAllActiveSegmentsPublicRef = (dc) => {
  const { dc: dcInstance} = validateArgs(connectorConfig, dc, undefined);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetAllActiveSegmentsPublic');
}
getAllActiveSegmentsPublicRef.operationName = 'GetAllActiveSegmentsPublic';

export function getAllActiveSegmentsPublic(dc) {
  return executeQuery(getAllActiveSegmentsPublicRef(dc));
}

export const getActiveSegmentBySubdomainPublicRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetActiveSegmentBySubdomainPublic', inputVars);
}
getActiveSegmentBySubdomainPublicRef.operationName = 'GetActiveSegmentBySubdomainPublic';

export function getActiveSegmentBySubdomainPublic(dcOrVars, vars) {
  return executeQuery(getActiveSegmentBySubdomainPublicRef(dcOrVars, vars));
}

export const getLocQuestionsRef = (dc) => {
  const { dc: dcInstance} = validateArgs(connectorConfig, dc, undefined);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetLocQuestions');
}
getLocQuestionsRef.operationName = 'GetLocQuestions';

export function getLocQuestions(dc) {
  return executeQuery(getLocQuestionsRef(dc));
}

export const getSegmentRegistrationRequirementPublicRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetSegmentRegistrationRequirementPublic', inputVars);
}
getSegmentRegistrationRequirementPublicRef.operationName = 'GetSegmentRegistrationRequirementPublic';

export function getSegmentRegistrationRequirementPublic(dcOrVars, vars) {
  return executeQuery(getSegmentRegistrationRequirementPublicRef(dcOrVars, vars));
}

export const getLocationQuestionsPublicRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetLocationQuestionsPublic', inputVars);
}
getLocationQuestionsPublicRef.operationName = 'GetLocationQuestionsPublic';

export function getLocationQuestionsPublic(dcOrVars, vars) {
  return executeQuery(getLocationQuestionsPublicRef(dcOrVars, vars));
}

export const getMyAccountInformationRef = (dc) => {
  const { dc: dcInstance} = validateArgs(connectorConfig, dc, undefined);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetMyAccountInformation');
}
getMyAccountInformationRef.operationName = 'GetMyAccountInformation';

export function getMyAccountInformation(dc) {
  return executeQuery(getMyAccountInformationRef(dc));
}

export const getCategoryShipmentPresetRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetCategoryShipmentPreset', inputVars);
}
getCategoryShipmentPresetRef.operationName = 'GetCategoryShipmentPreset';

export function getCategoryShipmentPreset(dcOrVars, vars) {
  return executeQuery(getCategoryShipmentPresetRef(dcOrVars, vars));
}

export const getLocationInformationRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetLocationInformation', inputVars);
}
getLocationInformationRef.operationName = 'GetLocationInformation';

export function getLocationInformation(dcOrVars, vars) {
  return executeQuery(getLocationInformationRef(dcOrVars, vars));
}

export const getUserSegmentsRef = (dc) => {
  const { dc: dcInstance} = validateArgs(connectorConfig, dc, undefined);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetUserSegments');
}
getUserSegmentsRef.operationName = 'GetUserSegments';

export function getUserSegments(dc) {
  return executeQuery(getUserSegmentsRef(dc));
}

export const getStatusInformationRef = (dc) => {
  const { dc: dcInstance} = validateArgs(connectorConfig, dc, undefined);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetStatusInformation');
}
getStatusInformationRef.operationName = 'GetStatusInformation';

export function getStatusInformation(dc) {
  return executeQuery(getStatusInformationRef(dc));
}

export const getGooglePlaceIdsRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetGooglePlaceIds', inputVars);
}
getGooglePlaceIdsRef.operationName = 'GetGooglePlaceIds';

export function getGooglePlaceIds(dcOrVars, vars) {
  return executeQuery(getGooglePlaceIdsRef(dcOrVars, vars));
}

export const getTeamMemberLocationsRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetTeamMemberLocations', inputVars);
}
getTeamMemberLocationsRef.operationName = 'GetTeamMemberLocations';

export function getTeamMemberLocations(dcOrVars, vars) {
  return executeQuery(getTeamMemberLocationsRef(dcOrVars, vars));
}

export const listAllLocationsRef = (dc) => {
  const { dc: dcInstance} = validateArgs(connectorConfig, dc, undefined);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'ListAllLocations');
}
listAllLocationsRef.operationName = 'ListAllLocations';

export function listAllLocations(dc) {
  return executeQuery(listAllLocationsRef(dc));
}

export const startFulfillmentRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'StartFulfillment', inputVars);
}
startFulfillmentRef.operationName = 'StartFulfillment';

export function startFulfillment(dcOrVars, vars) {
  return executeMutation(startFulfillmentRef(dcOrVars, vars));
}

export const startFulfillmentShippingRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'StartFulfillmentShipping', inputVars);
}
startFulfillmentShippingRef.operationName = 'StartFulfillmentShipping';

export function startFulfillmentShipping(dcOrVars, vars) {
  return executeMutation(startFulfillmentShippingRef(dcOrVars, vars));
}

export const upsertParcelDimensionsRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'UpsertParcelDimensions', inputVars);
}
upsertParcelDimensionsRef.operationName = 'UpsertParcelDimensions';

export function upsertParcelDimensions(dcOrVars, vars) {
  return executeMutation(upsertParcelDimensionsRef(dcOrVars, vars));
}

export const updateShipmentIsBeingReconfiguredRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'UpdateShipmentIsBeingReconfigured', inputVars);
}
updateShipmentIsBeingReconfiguredRef.operationName = 'UpdateShipmentIsBeingReconfigured';

export function updateShipmentIsBeingReconfigured(dcOrVars, vars) {
  return executeMutation(updateShipmentIsBeingReconfiguredRef(dcOrVars, vars));
}

export const createMyUserRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'CreateMyUser', inputVars);
}
createMyUserRef.operationName = 'CreateMyUser';

export function createMyUser(dcOrVars, vars) {
  return executeMutation(createMyUserRef(dcOrVars, vars));
}

export const updateMyUserRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'UpdateMyUser', inputVars);
}
updateMyUserRef.operationName = 'UpdateMyUser';

export function updateMyUser(dcOrVars, vars) {
  return executeMutation(updateMyUserRef(dcOrVars, vars));
}

export const activateMyUserStatusRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'ActivateMyUserStatus', inputVars);
}
activateMyUserStatusRef.operationName = 'ActivateMyUserStatus';

export function activateMyUserStatus(dcOrVars, vars) {
  return executeMutation(activateMyUserStatusRef(dcOrVars, vars));
}

export const createInitialUserRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'CreateInitialUser', inputVars);
}
createInitialUserRef.operationName = 'CreateInitialUser';

export function createInitialUser(dcOrVars, vars) {
  return executeMutation(createInitialUserRef(dcOrVars, vars));
}

export const activateUserSegmentStatusIfUserIsActiveRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'ActivateUserSegmentStatusIfUserIsActive', inputVars);
}
activateUserSegmentStatusIfUserIsActiveRef.operationName = 'ActivateUserSegmentStatusIfUserIsActive';

export function activateUserSegmentStatusIfUserIsActive(dcOrVars, vars) {
  return executeMutation(activateUserSegmentStatusIfUserIsActiveRef(dcOrVars, vars));
}

export const initiateAddressRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'InitiateAddress', inputVars);
}
initiateAddressRef.operationName = 'InitiateAddress';

export function initiateAddress(dcOrVars, vars) {
  return executeMutation(initiateAddressRef(dcOrVars, vars));
}

export const attachShippingAddressRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'AttachShippingAddress', inputVars);
}
attachShippingAddressRef.operationName = 'AttachShippingAddress';

export function attachShippingAddress(dcOrVars, vars) {
  return executeMutation(attachShippingAddressRef(dcOrVars, vars));
}

export const attachPhysicalAndBillingAddressRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'AttachPhysicalAndBillingAddress', inputVars);
}
attachPhysicalAndBillingAddressRef.operationName = 'AttachPhysicalAndBillingAddress';

export function attachPhysicalAndBillingAddress(dcOrVars, vars) {
  return executeMutation(attachPhysicalAndBillingAddressRef(dcOrVars, vars));
}

export const createAddressRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'CreateAddress', inputVars);
}
createAddressRef.operationName = 'CreateAddress';

export function createAddress(dcOrVars, vars) {
  return executeMutation(createAddressRef(dcOrVars, vars));
}

export const updateUserRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'UpdateUser', inputVars);
}
updateUserRef.operationName = 'UpdateUser';

export function updateUser(dcOrVars, vars) {
  return executeMutation(updateUserRef(dcOrVars, vars));
}

export const addDisplayNameAndMobileToUserRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'AddDisplayNameAndMobileToUser', inputVars);
}
addDisplayNameAndMobileToUserRef.operationName = 'AddDisplayNameAndMobileToUser';

export function addDisplayNameAndMobileToUser(dcOrVars, vars) {
  return executeMutation(addDisplayNameAndMobileToUserRef(dcOrVars, vars));
}

export const createLocationRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'CreateLocation', inputVars);
}
createLocationRef.operationName = 'CreateLocation';

export function createLocation(dcOrVars, vars) {
  return executeMutation(createLocationRef(dcOrVars, vars));
}

export const updateLocationRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'UpdateLocation', inputVars);
}
updateLocationRef.operationName = 'UpdateLocation';

export function updateLocation(dcOrVars, vars) {
  return executeMutation(updateLocationRef(dcOrVars, vars));
}

export const upsertLocationAnswerRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'UpsertLocationAnswer', inputVars);
}
upsertLocationAnswerRef.operationName = 'UpsertLocationAnswer';

export function upsertLocationAnswer(dcOrVars, vars) {
  return executeMutation(upsertLocationAnswerRef(dcOrVars, vars));
}

export const sendMessageRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'SendMessage', inputVars);
}
sendMessageRef.operationName = 'SendMessage';

export function sendMessage(dcOrVars, vars) {
  return executeMutation(sendMessageRef(dcOrVars, vars));
}

export const setBuyerSeenRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'setBuyerSeen', inputVars);
}
setBuyerSeenRef.operationName = 'setBuyerSeen';

export function setBuyerSeen(dcOrVars, vars) {
  return executeMutation(setBuyerSeenRef(dcOrVars, vars));
}

export const setSellerSeenRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'setSellerSeen', inputVars);
}
setSellerSeenRef.operationName = 'setSellerSeen';

export function setSellerSeen(dcOrVars, vars) {
  return executeMutation(setSellerSeenRef(dcOrVars, vars));
}

export const createBlankInitialOrderRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'CreateBlankInitialOrder', inputVars);
}
createBlankInitialOrderRef.operationName = 'CreateBlankInitialOrder';

export function createBlankInitialOrder(dcOrVars, vars) {
  return executeMutation(createBlankInitialOrderRef(dcOrVars, vars));
}

export const removeItemFromCartRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'RemoveItemFromCart', inputVars);
}
removeItemFromCartRef.operationName = 'RemoveItemFromCart';

export function removeItemFromCart(dcOrVars, vars) {
  return executeMutation(removeItemFromCartRef(dcOrVars, vars));
}

export const removeAllItemsFromCartRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'RemoveAllItemsFromCart', inputVars);
}
removeAllItemsFromCartRef.operationName = 'RemoveAllItemsFromCart';

export function removeAllItemsFromCart(dcOrVars, vars) {
  return executeMutation(removeAllItemsFromCartRef(dcOrVars, vars));
}

export const updateCartWithTransactionIdRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'UpdateCartWithTransactionId', inputVars);
}
updateCartWithTransactionIdRef.operationName = 'UpdateCartWithTransactionId';

export function updateCartWithTransactionId(dcOrVars, vars) {
  return executeMutation(updateCartWithTransactionIdRef(dcOrVars, vars));
}

export const respondToFaultyClaimRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'RespondToFaultyClaim', inputVars);
}
respondToFaultyClaimRef.operationName = 'RespondToFaultyClaim';

export function respondToFaultyClaim(dcOrVars, vars) {
  return executeMutation(respondToFaultyClaimRef(dcOrVars, vars));
}

export const getReviewsForLocationRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetReviewsForLocation', inputVars);
}
getReviewsForLocationRef.operationName = 'GetReviewsForLocation';

export function getReviewsForLocation(dcOrVars, vars) {
  return executeQuery(getReviewsForLocationRef(dcOrVars, vars));
}

export const getReviewsForFulfillmentRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetReviewsForFulfillment', inputVars);
}
getReviewsForFulfillmentRef.operationName = 'GetReviewsForFulfillment';

export function getReviewsForFulfillment(dcOrVars, vars) {
  return executeQuery(getReviewsForFulfillmentRef(dcOrVars, vars));
}

export const getAllStatusesRef = (dc) => {
  const { dc: dcInstance} = validateArgs(connectorConfig, dc, undefined);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetAllStatuses');
}
getAllStatusesRef.operationName = 'GetAllStatuses';

export function getAllStatuses(dc) {
  return executeQuery(getAllStatusesRef(dc));
}

export const getSegmentBySlugPublicRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetSegmentBySlugPublic', inputVars);
}
getSegmentBySlugPublicRef.operationName = 'GetSegmentBySlugPublic';

export function getSegmentBySlugPublic(dcOrVars, vars) {
  return executeQuery(getSegmentBySlugPublicRef(dcOrVars, vars));
}

export const fileUploadRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'FileUpload', inputVars);
}
fileUploadRef.operationName = 'FileUpload';

export function fileUpload(dcOrVars, vars) {
  return executeMutation(fileUploadRef(dcOrVars, vars));
}

export const filesInRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'FilesIn', inputVars);
}
filesInRef.operationName = 'FilesIn';

export function filesIn(dcOrVars, vars) {
  return executeQuery(filesInRef(dcOrVars, vars));
}

export const getDigitalPurchasesRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'getDigitalPurchases', inputVars);
}
getDigitalPurchasesRef.operationName = 'getDigitalPurchases';

export function getDigitalPurchases(dcOrVars, vars) {
  return executeQuery(getDigitalPurchasesRef(dcOrVars, vars));
}

export const getFulfillmentsRef = (dc) => {
  const { dc: dcInstance} = validateArgs(connectorConfig, dc, undefined);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetFulfillments');
}
getFulfillmentsRef.operationName = 'GetFulfillments';

export function getFulfillments(dc) {
  return executeQuery(getFulfillmentsRef(dc));
}

export const getInteractionsByFulfillmentForBuyerOrSellerRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetInteractionsByFulfillmentForBuyerOrSeller', inputVars);
}
getInteractionsByFulfillmentForBuyerOrSellerRef.operationName = 'GetInteractionsByFulfillmentForBuyerOrSeller';

export function getInteractionsByFulfillmentForBuyerOrSeller(dcOrVars, vars) {
  return executeQuery(getInteractionsByFulfillmentForBuyerOrSellerRef(dcOrVars, vars));
}

export const getMyInteractionsRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetMyInteractions', inputVars);
}
getMyInteractionsRef.operationName = 'GetMyInteractions';

export function getMyInteractions(dcOrVars, vars) {
  return executeQuery(getMyInteractionsRef(dcOrVars, vars));
}

export const getAllInteractionsRef = (dc) => {
  const { dc: dcInstance} = validateArgs(connectorConfig, dc, undefined);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetAllInteractions');
}
getAllInteractionsRef.operationName = 'GetAllInteractions';

export function getAllInteractions(dc) {
  return executeQuery(getAllInteractionsRef(dc));
}

export const getAllNotificationLogsRef = (dc) => {
  const { dc: dcInstance} = validateArgs(connectorConfig, dc, undefined);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetAllNotificationLogs');
}
getAllNotificationLogsRef.operationName = 'GetAllNotificationLogs';

export function getAllNotificationLogs(dc) {
  return executeQuery(getAllNotificationLogsRef(dc));
}

export const upsertListingCoreRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'UpsertListingCore', inputVars);
}
upsertListingCoreRef.operationName = 'UpsertListingCore';

export function upsertListingCore(dcOrVars, vars) {
  return executeMutation(upsertListingCoreRef(dcOrVars, vars));
}

export const deleteListingVariationRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'DeleteListingVariation', inputVars);
}
deleteListingVariationRef.operationName = 'DeleteListingVariation';

export function deleteListingVariation(dcOrVars, vars) {
  return executeMutation(deleteListingVariationRef(dcOrVars, vars));
}

export const upsertListingVariationRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'UpsertListingVariation', inputVars);
}
upsertListingVariationRef.operationName = 'UpsertListingVariation';

export function upsertListingVariation(dcOrVars, vars) {
  return executeMutation(upsertListingVariationRef(dcOrVars, vars));
}

export const deleteAllImagesOnListingRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'DeleteAllImagesOnListing', inputVars);
}
deleteAllImagesOnListingRef.operationName = 'DeleteAllImagesOnListing';

export function deleteAllImagesOnListing(dcOrVars, vars) {
  return executeMutation(deleteAllImagesOnListingRef(dcOrVars, vars));
}

export const upsertListingImageRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'UpsertListingImage', inputVars);
}
upsertListingImageRef.operationName = 'UpsertListingImage';

export function upsertListingImage(dcOrVars, vars) {
  return executeMutation(upsertListingImageRef(dcOrVars, vars));
}

export const upsertListingAnswerRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'UpsertListingAnswer', inputVars);
}
upsertListingAnswerRef.operationName = 'UpsertListingAnswer';

export function upsertListingAnswer(dcOrVars, vars) {
  return executeMutation(upsertListingAnswerRef(dcOrVars, vars));
}

export const addUserWatchListingRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'AddUserWatchListing', inputVars);
}
addUserWatchListingRef.operationName = 'AddUserWatchListing';

export function addUserWatchListing(dcOrVars, vars) {
  return executeMutation(addUserWatchListingRef(dcOrVars, vars));
}

export const removeUserWatchListingRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'RemoveUserWatchListing', inputVars);
}
removeUserWatchListingRef.operationName = 'RemoveUserWatchListing';

export function removeUserWatchListing(dcOrVars, vars) {
  return executeMutation(removeUserWatchListingRef(dcOrVars, vars));
}

export const getAllCategoriesRef = (dc) => {
  const { dc: dcInstance} = validateArgs(connectorConfig, dc, undefined);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetAllCategories');
}
getAllCategoriesRef.operationName = 'GetAllCategories';

export function getAllCategories(dc) {
  return executeQuery(getAllCategoriesRef(dc));
}

export const getListingQuestionsForCategoryPublicRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetListingQuestionsForCategoryPublic', inputVars);
}
getListingQuestionsForCategoryPublicRef.operationName = 'GetListingQuestionsForCategoryPublic';

export function getListingQuestionsForCategoryPublic(dcOrVars, vars) {
  return executeQuery(getListingQuestionsForCategoryPublicRef(dcOrVars, vars));
}

export const getListingsRef = (dc) => {
  const { dc: dcInstance} = validateArgs(connectorConfig, dc, undefined);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetListings');
}
getListingsRef.operationName = 'GetListings';

export function getListings(dc) {
  return executeQuery(getListingsRef(dc));
}

export const getListingRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetListing', inputVars);
}
getListingRef.operationName = 'GetListing';

export function getListing(dcOrVars, vars) {
  return executeQuery(getListingRef(dcOrVars, vars));
}

export const readOrdersRef = (dc) => {
  const { dc: dcInstance} = validateArgs(connectorConfig, dc, undefined);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'ReadOrders');
}
readOrdersRef.operationName = 'ReadOrders';

export function readOrders(dc) {
  return executeQuery(readOrdersRef(dc));
}

export const purchasePageOrdersRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'PurchasePageOrders', inputVars);
}
purchasePageOrdersRef.operationName = 'PurchasePageOrders';

export function purchasePageOrders(dcOrVars, vars) {
  return executeQuery(purchasePageOrdersRef(dcOrVars, vars));
}

export const fulfillmentPageOrdersRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'FulfillmentPageOrders', inputVars);
}
fulfillmentPageOrdersRef.operationName = 'FulfillmentPageOrders';

export function fulfillmentPageOrders(dcOrVars, vars) {
  return executeQuery(fulfillmentPageOrdersRef(dcOrVars, vars));
}

export const getOrderRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetOrder', inputVars);
}
getOrderRef.operationName = 'GetOrder';

export function getOrder(dcOrVars, vars) {
  return executeQuery(getOrderRef(dcOrVars, vars));
}

export const getFulfillmentOrderRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetFulfillmentOrder', inputVars);
}
getFulfillmentOrderRef.operationName = 'GetFulfillmentOrder';

export function getFulfillmentOrder(dcOrVars, vars) {
  return executeQuery(getFulfillmentOrderRef(dcOrVars, vars));
}

export const getFulfillmentRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetFulfillment', inputVars);
}
getFulfillmentRef.operationName = 'GetFulfillment';

export function getFulfillment(dcOrVars, vars) {
  return executeQuery(getFulfillmentRef(dcOrVars, vars));
}

export const doStockCheckRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'doStockCheck', inputVars);
}
doStockCheckRef.operationName = 'doStockCheck';

export function doStockCheck(dcOrVars, vars) {
  return executeQuery(doStockCheckRef(dcOrVars, vars));
}

export const getStuffRef = (dc) => {
  const { dc: dcInstance} = validateArgs(connectorConfig, dc, undefined);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'getStuff');
}
getStuffRef.operationName = 'getStuff';

export function getStuff(dc) {
  return executeQuery(getStuffRef(dc));
}

export const addSystemAsAUserRef = (dc) => {
  const { dc: dcInstance} = validateArgs(connectorConfig, dc, undefined);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'addSystemAsAUser');
}
addSystemAsAUserRef.operationName = 'addSystemAsAUser';

export function addSystemAsAUser(dc) {
  return executeMutation(addSystemAsAUserRef(dc));
}

export const insertMainStatusesRef = (dc) => {
  const { dc: dcInstance} = validateArgs(connectorConfig, dc, undefined);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'InsertMainStatuses');
}
insertMainStatusesRef.operationName = 'InsertMainStatuses';

export function insertMainStatuses(dc) {
  return executeMutation(insertMainStatusesRef(dc));
}

export const insertMainSegmentsRef = (dc) => {
  const { dc: dcInstance} = validateArgs(connectorConfig, dc, undefined);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'InsertMainSegments');
}
insertMainSegmentsRef.operationName = 'InsertMainSegments';

export function insertMainSegments(dc) {
  return executeMutation(insertMainSegmentsRef(dc));
}

export const readMainStatusRef = (dc) => {
  const { dc: dcInstance} = validateArgs(connectorConfig, dc, undefined);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'ReadMainStatus');
}
readMainStatusRef.operationName = 'ReadMainStatus';

export function readMainStatus(dc) {
  return executeQuery(readMainStatusRef(dc));
}

export const getItemsRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetItems', inputVars);
}
getItemsRef.operationName = 'GetItems';

export function getItems(dcOrVars, vars) {
  return executeQuery(getItemsRef(dcOrVars, vars));
}

export const createPlaceHolderImageRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'CreatePlaceHolderImage', inputVars);
}
createPlaceHolderImageRef.operationName = 'CreatePlaceHolderImage';

export function createPlaceHolderImage(dcOrVars, vars) {
  return executeMutation(createPlaceHolderImageRef(dcOrVars, vars));
}

export const imageUploadRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'ImageUpload', inputVars);
}
imageUploadRef.operationName = 'ImageUpload';

export function imageUpload(dcOrVars, vars) {
  return executeMutation(imageUploadRef(dcOrVars, vars));
}

export const imagesInRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'ImagesIn', inputVars);
}
imagesInRef.operationName = 'ImagesIn';

export function imagesIn(dcOrVars, vars) {
  return executeQuery(imagesInRef(dcOrVars, vars));
}

export const allImagesRef = (dc) => {
  const { dc: dcInstance} = validateArgs(connectorConfig, dc, undefined);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'AllImages');
}
allImagesRef.operationName = 'AllImages';

export function allImages(dc) {
  return executeQuery(allImagesRef(dc));
}

